import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/rekrut/candidates')({
  component: () => <Outlet />,
});
